import { createI18n } from 'vue-i18n';
import {
  messagesFR_CH,
  FALLBACK_LOCALE,
  detectInitialLocale,
  type MessageSchema,
  type SupportedLocale,
} from './locales';

/**
 * Instance i18n unique de l'app — créée une seule fois, importée partout
 * où on a besoin d'accéder à i18n.global (auth store, composables, etc.).
 */
// Le 3e generic `false` indique mode Composition API (legacy:false).
// Sans ça, TypeScript pense que c'est legacy:true et `i18n.global.locale`
// devient un string direct au lieu d'un Ref<string>.
export const i18n = createI18n<[MessageSchema], SupportedLocale, false>({
  legacy: false,
  locale: detectInitialLocale(),
  fallbackLocale: FALLBACK_LOCALE,
  messages: {
    'fr-CH': messagesFR_CH,
  } as any,
  missingWarn: import.meta.env.DEV,
  fallbackWarn: false,
});
